// extracted by mini-css-extract-plugin
module.exports = {"circularProgressContainer":"Loader_circularProgressContainer__nIuPZ","circularProgressPercents":"Loader_circularProgressPercents__iYUcY"};